import axios from "axios"

export const rootUrl = axios.create ({baseURL:"https://erp.apitco.org:8084",})

export const APP_BASE_URL = "https://rms.jvdindia.com";
